import script from "./EventsAndActivityPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsAndActivityPanel.vue?vue&type=script&lang=ts&setup=true"

import "./EventsAndActivityPanel.vue?vue&type=style&index=0&id=276fa044&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-276fa044"]])

export default __exports__